// extracted by mini-css-extract-plugin
export var boldText = "_5g-4";
export var checkboxContainer = "_5g-6";
export var closeIcon = "_5g-i";
export var container = "_5g-0";
export var drawer = "_5g-8";
export var drawerContent = "_5g-9";
export var extraSmallText = "_5g-5";
export var fulfillmentGroupTable = "_5g-e";
export var largeText = "_5g-3";
export var loadingSpinnerContainer = "_5g-j";
export var mediumText = "_5g-2";
export var narrow = "_5g-f";
export var notificationLink = "_5g-l";
export var packageCheckIconContainer = "_5g-7";
export var slideoutHeaderActions = "_5g-g";
export var slideoutHeaderActionsShifted = "_5g-h";
export var slideoutHeaderContainer = "_5g-a";
export var slideoutModal = "_5g-c";
export var stickyHeaderWrapper = "_5g-b";
export var table = "_5g-k";
export var tableContainer = "_5g-d";
export var tertiaryText = "_5g-1";